import Navbar from "../Components/Navbar";
import Form from '../Components/Profile/ProfileForm';

function ProfileForm(){
  return(
    <>
      <Navbar/>
      <Form />
    </>
  );
}

export default ProfileForm;